/**
 *  @class
 *  @function TabsStripe
 */
if (!customElements.get("tabs-stripe")) {
  class TabsStripe extends HTMLElement {
    constructor() {
      super();

      this.tabHeaders = this.querySelectorAll(".tab-header");
      this.contentContainers = this.querySelectorAll(".tab-content");

      this.addEventListeners();
    }

    addEventListeners() {
      this.tabHeaders.forEach((tabHeader) => {
        tabHeader.addEventListener("click", (e) => {
          const currentActiveTab = this.querySelector(".tab-header-container .active");
          if (e.target.dataset.title !== currentActiveTab.dataset.title) {
            this.toggleActiveTab(e.target);
          }
        });
      });
    }

    toggleActiveTab(target) {
      this.removeActiveClasses();

      target.classList.add("active");
      this.contentContainers.forEach((contentContainer) => {
        if (target.dataset.title === contentContainer.dataset.title) {
          contentContainer.classList.add("active");
        }
      });
    }

    removeActiveClasses() {
      this.tabHeaders.forEach((tabHeader) => {
        tabHeader.classList.remove("active");
      });
      this.contentContainers.forEach((contentContainer) => {
        contentContainer.classList.remove("active");
      });
    }
  }
  customElements.define("tabs-stripe", TabsStripe);
}
